window.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".open-form").forEach(function (el) {
        el.addEventListener("click", function (event) {
            const formSelection = event.target.href;
            let form;
            if (formSelection.includes("/")) {
                event.preventDefault();
                const splitted = formSelection.split("/");
                const formId = splitted[splitted.length - 1];
                if (!formId.includes("#")) return;
                form = document.querySelector(formId);
            } else if (formSelection.startsWith("#")) {
                event.preventDefault();
                form = document.querySelector(formSelection);
            }
            if (!form) return;
            if (!event.target.classList.contains("form-opened")) {
                form.style = "display: block;"
                form.scrollIntoView({behavior: "smooth"})
            } else {
                form.style = ""
            }
            event.target.classList.toggle("form-opened");
        })
    });
})
